import * as React from "react";
import {Link, useLocation} from 'react-router-dom'; // Import Link and useLocation
import {
    ArrowUpCircleIcon,
    BarChartIcon,
    CameraIcon,
    ClipboardListIcon,
    DatabaseIcon,
    FileCodeIcon,
    FileIcon,
    FileTextIcon,
    FolderIcon,
    HelpCircleIcon,
    GaugeIcon,
    MapPinIcon,
    ListIcon,
    SearchIcon,
    SettingsIcon,
    UsersIcon,
    RecycleIcon,
    TrendingDownIcon,
    ChartColumnIncreasingIcon,
    ScaleIcon,
    LayoutGridIcon,
    Locate,
    ChartBarIcon,
    HomeIcon,
    BellIcon,
    Lightbulb,
} from "lucide-react";

import {NavDocuments} from "@/components/nav-documents";
import {NavMain} from "@/components/nav-main";
import {NavSecondary} from "@/components/nav-secondary";
import {NavUser} from "@/components/nav-user";
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from "@/components/ui/sidebar";

//import logo from "@/assets/images/logo_white.png";
import logo from "@/assets/svg/plaexLogo.svg";
import axiosInstance from "@/api/axios";
import ThemeToggle from "@/pages/contexts/ThemeTogglee";
import {useTranslation} from "react-i18next";


export function AppSidebar({userRole = "Basic", ...props}) {

    const [showNotifications, setShowNotifications] = React.useState(false);
    const [notifications, setNotifications] = React.useState([
        {text: "R1 in PLAEX Office is 80% full. Please empty it.", time: "2 hours ago", unread: true},
        {text: "R13 in Cafeteria is 75% full. Please empty it.", time: "7 hours ago", unread: true},
        {text: "Sensor malfunction detected in Warehouse A - Bin 5.", time: "1 day ago", unread: false},
        {text: "New software update available.", time: "3 days ago", unread: false},
    ]);

    const {t, i18n} = useTranslation();

    const location = useLocation();
    const [userData, setUserData] = React.useState({
        name: "shadcn",
        email: "m@example.com",
        avatar: "/avatars/shadcn.jpg",
    });

    React.useEffect(() => {
        axiosInstance
            .get("")
            .then((response) => {
                setUserData({
                    name: response.data.company || "shadcn",
                    email: response.data.email || "m@example.com",
                    avatar: response.data.user_profile || "/avatars/shadcn.jpg",
                });
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    const getSidebarData = () => {
        // Define navigation items with their visibility based on role
       const navItems = [
    {
        title: t("home"),
        url: "/homepage",
        icon: HomeIcon,
        visible: userRole === "Business"
    },
    {
        title: t("operations"),
        url: "/operations",
        icon: GaugeIcon,
        visible: true
    },
    {
        title: t("facility"),
        url: "/facility",
        icon: Locate,
        visible: userRole === "Business"
    },
    {
        title: t("locations"),
        url: "/locations",
        icon: MapPinIcon,
        visible: userRole === "Business"
    },
    {
        title: t("circularity"),
        url: "/circularity",
        icon: RecycleIcon,
        visible: userRole === "Mid" || userRole === "Business"  // CHANGE THIS LINE
    },
    {
        title: t("costSavingstitle"),
        url: "/cost-savings",
        icon: TrendingDownIcon,
        visible: userRole === "Mid" || userRole === "Business"  // CHANGE THIS LINE
    },
    {
        title: t("other"),
        url: "/other",
        icon: ChartBarIcon,
        visible: userRole === "Business"
    },
];

        const navSecondary = [
            {
                title: t("feedbacktitle"),
                url: "/feedback",
                icon: Lightbulb,
                visible: true // Visible to all users
            }
        ]
        const data = {
            user: userData,
            navMain: navItems.filter(item => item.visible),
            navSecondary: navSecondary.filter(item => item.visible)
        };

        return data;
    };

    const data = getSidebarData(props);

    return (
        <Sidebar collapsible="icon" {...props}>
<SidebarHeader>
    <SidebarMenu>
        <SidebarMenuItem>
            <div className="flex items-center justify-between w-full pr-2">
                <SidebarMenuButton
                    asChild
                    className="data-[slot=sidebar-menu-button]:!p-1.5 flex items-center gap-2"
                >
                    <Link to="/operations" className="flex items-center gap-2">
                        <img src={logo} alt="logo" className="size-10 dark:invert"/>
                        <span className="text-base font-semibold">PLAEX</span>
                    </Link>
                </SidebarMenuButton>
                
                  <ThemeToggle />
                 

            </div>
        </SidebarMenuItem>
    </SidebarMenu>
</SidebarHeader>

            <SidebarContent>
                <NavMain items={data.navMain}/>
                <NavSecondary items={data.navSecondary} className="mt-auto"/>
            </SidebarContent>
            <SidebarFooter className="relative">
                {/* Notifications */}
                {/*
            <div className="relative px-4 py-2">
                <button
                    onClick={() => setShowNotifications((prev) => !prev)}
                    className="relative focus:outline-none z-10"
                    aria-expanded={showNotifications}
                    aria-controls="notifications-popup"
                    >
                    <BellIcon className="w-5 h-5 text-gray-600" />
                    {notifications.filter(n => n.unread).length > 0 && (
                    <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                        {notifications.filter(n => n.unread).length}
                    </span>
                    )}
                </button>



                {showNotifications && (
                <div
                    id="notifications-popup"
                    className="absolute bottom-full mb-2 left-0 w-[240px] bg-white border rounded-lg shadow-lg z-20 p-3 transition-opacity duration-200 ease-in-out"
                >
                    <div className="font-semibold text-sm mb-2">Notifications</div>
                    <ul className="space-y-2 text-sm max-h-60 overflow-y-auto">
                        {notifications.map(({ text, time, unread }, index) => (
                        <li
                        key={index}
                        onClick={() => {
                            if (unread) {
                            setNotifications(prev =>
                                prev.map((n, i) =>
                                i === index ? { ...n, unread: false } : n
                                )
                            );
                            }
                        }}
                        className={`cursor-pointer ${
                            unread
                            ? "bg-blue-50 font-semibold text-blue-900 rounded px-2 py-1"
                            : "text-gray-700"
                        }`}
                        >
                        {unread && (
                            <span
                            className="inline-block w-2 h-2 mr-1 mb-0.5 align-middle rounded-full bg-blue-500"
                            aria-label="Unread notification"
                            />
                        )}
                        <p className="text-sm">{text}</p>
                        <time className="block text-xs text-gray-400 mt-1 text-right">{time}</time>
                        </li>
                        ))}
                    </ul>
                    </div>
                )}
            </div>


            */}


                {/* User Info */}
                <NavUser user={data.user}/>
            </SidebarFooter>
        </Sidebar>
    );
}
